import {
  compareDateOnly,
  dateOnlyToLocalDate,
  getBerlinTodayDateOnly,
  getBerlinTomorrowDateOnly,
  isValidDateOnly,
} from "@/utils/closingTimes/berlinDateOnly";

export const getEarliestClosingTimeRequestStartDate = (
  now = new Date(),
): Date => {
  const tomorrow = dateOnlyToLocalDate(getBerlinTomorrowDateOnly(now));
  if (!tomorrow) {
    throw new Error("Unable to determine tomorrow in Europe/Berlin");
  }

  return tomorrow;
};

export const isClosingTimeRequestStartDateAllowed = (
  startDate: string | null | undefined,
  now = new Date(),
): boolean => {
  if (!startDate) {
    return false;
  }

  const comparison = compareDateOnly(startDate, getBerlinTodayDateOnly(now));
  return comparison !== null && comparison > 0;
};

export const isClosingTimeRequestDateRangeAllowed = (
  startDate: string | null | undefined,
  endDate: string | null | undefined,
  now = new Date(),
): boolean => {
  if (
    !startDate ||
    !endDate ||
    !isClosingTimeRequestStartDateAllowed(startDate, now)
  ) {
    return false;
  }

  if (!isValidDateOnly(endDate)) {
    return false;
  }

  const comparison = compareDateOnly(endDate, startDate);
  return comparison !== null && comparison >= 0;
};
